import produce from 'immer';
import { AnyAction } from 'redux';
import {
  GET_RESERVE_HISTORY_REQUEST,
  GET_RESERVE_HISTORY_SUCCESS,
  GET_RESERVE_HISTORY_FAILURE,
  GET_RESERVE_HISTORY_INITIAL,
} from '../../actions';

export type GetReserveHistoryStateType = {
  isGetReserveHistoryLoading: boolean;
  isGetReserveHistoryLoaded: boolean;
  getReserveHistory: GetReserveHistoryType;
};

type GetReserveHistoryType = {
  result: number;
  data: ReserveHistoryDataType;
};

type ReserveHistoryDataType = {
  now_reserve_list: ReserveDataType[];
  wait_cancel_list: ReserveDataType[];
  past_reserve_list: ReserveDataType[];
};

export type ReserveDataType = {
  data_id: number;
  schedule_id: number;
  companion: number | null;
  schedule_date: string | null;
  start_time: string | null;
  end_time: string | null;
  cancel_abled_day: number | null;
  cancel_abled_hours: number | null;
  cancel_abled_minutes: number | null;
  alternate_label: string | null;
  contents_id: number | null;
  contents_annex_flag: number | null;
  contents_web_show_name: string | null;
  contents_classification: number | null;
  follow_people_upper: string | null;
  club_equipment_annex_flag: number | null;
  installed_seats_name: string | null;
  club_annex_flag: number | null;
  club_web_show_name: string | null;
  open_date: string | null;
  telephone_number: string | null;
  post_id: string | null;
  address: string | null;
  addr_buildname: string | null;
  annex_post_id: string | null;
  annex_address: string | null;
  annex_addr_buildname: string | null;
  layout_picture: string | null;
  reserve_time: string | null;
  reserve_time_label: string | null;
  cancel_time: string | null;
  cancel_time_label: string | null;
};

const initialState: GetReserveHistoryStateType = {
  isGetReserveHistoryLoading: false,
  isGetReserveHistoryLoaded: false,
  getReserveHistory: {
    result: -1,
    data: {
      now_reserve_list: [],
      wait_cancel_list: [],
      past_reserve_list: [],
    },
  },
};

const getReserveHistoryReducer = (state = initialState, action: AnyAction): GetReserveHistoryStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_RESERVE_HISTORY_REQUEST:
        dataState.isGetReserveHistoryLoading = true;
        dataState.isGetReserveHistoryLoaded = false;
        dataState.getReserveHistory.result = initialState.getReserveHistory.result;
        dataState.getReserveHistory.data = initialState.getReserveHistory.data;
        break;
      case GET_RESERVE_HISTORY_SUCCESS:
        dataState.isGetReserveHistoryLoading = false;
        dataState.isGetReserveHistoryLoaded = true;
        dataState.getReserveHistory.result = action.res.data.result;
        dataState.getReserveHistory.data = action.res.data.data;
        break;
      case GET_RESERVE_HISTORY_FAILURE:
        dataState.isGetReserveHistoryLoading = false;
        dataState.isGetReserveHistoryLoaded = false;
        dataState.getReserveHistory.result = initialState.getReserveHistory.result;
        dataState.getReserveHistory.data = initialState.getReserveHistory.data;
        break;
      case GET_RESERVE_HISTORY_INITIAL:
        dataState.isGetReserveHistoryLoading = false;
        dataState.isGetReserveHistoryLoaded = false;
        dataState.getReserveHistory.result = initialState.getReserveHistory.result;
        dataState.getReserveHistory.data = initialState.getReserveHistory.data;
        break;
      default:
        break;
    }
  });
};

export default getReserveHistoryReducer;
